module.exports = __webpack_public_path__ + "media/images/vp/parallax.01.3-83962479adb438254af633e6ca4af54d.png";